import { render, staticRenderFns } from "./warehouse-stock.vue?vue&type=template&id=d4544e28&scoped=true"
import script from "./warehouse-stock.vue?vue&type=script&lang=js"
export * from "./warehouse-stock.vue?vue&type=script&lang=js"
import style0 from "./warehouse-stock.vue?vue&type=style&index=0&id=d4544e28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4544e28",
  null
  
)

export default component.exports